'use strict';

import request from 'superagent';
import api from './core';

export function emptyContract() {
    return {
        id: undefined,
        number: undefined,
        company: undefined,
        type: undefined,
        client: undefined,
        wire_initial: undefined,
        wire_monthly: undefined,
        wire_period: 'monthly',
        all_numbers: [],
        processes: [],
        producer_interests: [],
        date_start: undefined,
        date_transfer: undefined,
        date_reject: undefined,
        date_stop: undefined,
        allocation: null
    };
}

function toMonthly(months, amount) {
    if (months) {
        return amount / months;
    }
    return 0;
}

function toPeriod(months, amount) {
    return months * amount;
}

export function wirePeriods() {
    return [
        {
            label: 'Aucune',
            value: 'none',
            months: 0,
            monthly: (amount) => toMonthly(0, amount),
            periodic: (amount) => toPeriod(0, amount)
        },
        {
            label: 'Mensuel',
            value: 'monthly',
            months: 1,
            monthly: (amount) => toMonthly(1, amount),
            periodic: (amount) => toPeriod(1, amount)
        },
        {
            label: 'Trimestriel',
            value: 'quarterly',
            months: 3,
            monthly: (amount) => toMonthly(3, amount),
            periodic: (amount) => toPeriod(3, amount)
        },
        {
            label: 'Semestriel',
            value: 'biannually',
            months: 6,
            monthly: (amount) => toMonthly(6, amount),
            periodic: (amount) => toPeriod(6, amount)
        },
        {
            label: 'Annuel',
            value: 'annually',
            months: 12,
            monthly: (amount) => toMonthly(12, amount),
            periodic: (amount) => toPeriod(12, amount)
        }
    ];
}

export function emptyProducerInterest(producer) {
    return {
        producer,
        pu: 0,
        pp: 0,
        reprise: 0
    };
}

export function create(contract) {
    return api.forwardResult(
        api.prepare(request.post(api.url('/contracts/'))).send(contract),
        'id'
    );
}

export function update(contract) {
    const id = encodeURIComponent(contract.id);
    console.log({contract});
    return api.forwardResult(
        api.prepare(request.put(api.url(`/contracts/${id}/`))).send(contract),
        'id'
    );
}

/**
 * Fetches a signe contract.
 *
 * @param id {*} ID of the contract to fetch
 * @param full {Boolean} If set to true, the request will ask the server to
 *                       compute all properties, aka to include the
 *                       `compatible_allocations` properties
 * @return {Promise | Promise<unknown>}
 */
export function fetch(id, full = false) {
    let extra = '';

    if (full) {
        extra = '?full';
    }

    return api.forwardResult(
        api.prepare(request.get(api.url(`/contracts/${id}/${extra}`))), 'id'
    );
}

export function listPage(client = {}, page = 1, company = null, q) {
    return api.forwardResult(
        api.prepare(request.get(api.url('/contracts/')).query({q, page, client, company})),
        'results'
    );
}

export async function list(client, company = null, q = '') {
    const out = [];
    let hasNext = true;
    let page = 1;

    while (hasNext) {
        const list = await listPage(client, page, company, q);
        out.push(...list.results);
        page += 1;
        hasNext = !!list.next;
    }

    return out;
}

export async function sendMail(contract, mail) {
    const id = encodeURIComponent(contract.id);
    return api.forwardResult(
        api.prepare(request.post(api.url(`/contracts/${id}/send_email/`))).send(mail),
        'ok'
    );
}

export function downloadUrl(client, company = null, q = '') {
    return api.forwardResult(
        api.prepare(request.get(api.url('/contracts/excel/')).query({q, client, company})),
        'url'
    );
}

/**
 * Fetches historical data for the contract from the API
 *
 * @param contractId ID of the contract
 */
export function getHistoricalData({contractId}) {
    const id = encodeURIComponent(contractId);
    return api.forwardResult(
        api.prepare(
            request.get(api.url(`/contracts/${id}/historical_data/`))
        ).send(),
        'funds'
    );
}



// WEBPACK FOOTER //
// ./src/api/contract.js